import {
  HeartIcon,
  ShareIcon,
} from "@heroicons/react/24/solid";
import NavBar from "../../components/Navigation/NavBar";
import Footer from "../../components/Footer/Footer";
import Carousel from "../../components/Carousel";
import Calendar from "../../components/Calendar";
import { motion } from 'framer-motion';
import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { getSellById } from "../../services/firestore/sellService"; 
import { Helmet } from "react-helmet";


const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.5 } },
  exit: { opacity: 0, transition: { duration: 0.3 } },
};
function SellDetailPage() {
 const { id } = useParams();
  const location = useLocation();
  const [item, setItem] = useState(location.state?.item || null);
  const currentURL = window.location.href;

  useEffect(() => {
    if (!item && id) {
      getSellById(id).then((data) => {
        if (data) {
          setItem(data);
        } else {
          console.warn("Item not found for ID:", id);
        }
      });
    }
  }, [id, item]);

  if (!item) {
    return <div>Item not found. Please go back to listings.</div>;
  }

  return (
    <>
    <Helmet>
     <title>{item ? item.title : "Sell Items"}</title>
      <meta name="description" content={item ? item.description : "Sell description"}/>
      <meta name="keywords" content={item ? item.description : "Sell keywords"} />
      <meta property="og:title" content={item ? item.title : "Sell Items"} />
      <meta property="og:description" content={item ? item.description : "Sell description"} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://www.nextloop.sg/sell/${id}`} />
      </Helmet>
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <NavBar />
      <div className="max-w-6xl mx-auto mt-28 px-4 mb-16">
       <nav class="flex pb-4" aria-label="Breadcrumb">
          <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
            <li class="inline-flex items-center">
              <a href="/" class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-600">
                <svg class="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
                </svg>
                Home
              </a>
            </li>
            <li>
              <div class="flex items-center">
                <svg class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4" />
                </svg>
                <a class="ms-1 text-sm font-medium md:ms-2 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-600 text-gray-700 ">Sell</a>
              </div>
            </li>
            <li>
              <div class="flex items-center">
                <svg class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4" />
                </svg>
                <a class="ms-1 text-sm font-medium md:ms-2 text-gray-400 ">{item.title}</a>
              </div>
            </li>

          </ol>
        </nav>
      <div>
        
        <div className="flex flex-col-reverse lg:grid lg:grid-cols-2 gap-8">
          {/* LEFT: Title, Price, Description, Calendar */}
          <div className="space-y-6 relative">
            

            <h1 className="text-3xl font-semibold text-gray-900 mt-1 pr-10">{item.title}</h1>
            <p className="text-gray-700 whitespace-pre-line">
  {item.description}
</p>
            

            {/* Placeholder Calendar */}
            {/* <div className="mt-6 border rounded-lg p-4 text-center text-gray-500 bg-gray-50">
                <Calendar></Calendar>
                                            
            </div> */}
          </div>

          {/* RIGHT: Carousel, Heart, User, Book Button */}
          <div className="space-y-6">
            {/* Carousel */}
            <Carousel item={item}></Carousel>
            {/* Favourite Icon */}
            <div className="flex justify-between">
              <div className="text-2xl font-bold text-blue-600">{item.rentalDaily ? `$${item.rentalDaily}` : "Free"}</div>
            <div className="flex justify-end">
               
              <button className="p-2 rounded-full border border-gray-300 hover:bg-gray-100">
                <HeartIcon className="h-6 w-6 text-red-500" />
              </button>
             
              <button className="p-2 rounded-full border border-gray-300 hover:bg-gray-100 ml-2">
                <ShareIcon className="h-5 w-5 text-gray-600" />
              </button>
      </div>
            </div>

            {/* User Info + Posted Time */}
            <div className="flex items-center gap-4">
              <img
                src={item.employerUser.photo_url}
                alt={item.employerUser.handleName}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <div className="font-medium text-gray-900">{item.employerUser.handleName}</div>
                <div className="text-sm text-gray-500">{item.timePosted.toDate().toLocaleString()}</div>
              </div>
            </div>
            <a
                  href={`https://wa.me/6591599414?text=${encodeURIComponent(
                    `Hi! I am interested in "${item.title}".\n${currentURL}`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center w-full px-4 py-3 bg-green-500 text-white font-semibold rounded-lg shadow hover:bg-green-600 transition gap-2"
                >
                  <i className="fab fa-whatsapp text-xl"></i>
                  <span>WhatsApp Us</span>
                </a>

            {/* Book Button */}
            {/* <div>
              <button className="w-full bg-blue-600 text-white text-lg px-4 py-2 rounded-lg hover:bg-blue-700 transition">
                Book Now
              </button>
            </div> */}
          </div>
        </div>
      </div>
      </div>
      <Footer />
      </motion.div>
    </>
  );
}

export default SellDetailPage;
